import React from "react";
import { TreeRuleNode, TreeRuleNodeType } from "../../../rule-engine-core/Rule/Tree/Structure/TreeRuleNode";

import { TreeRuleEditContext } from "../../../rule-engine-core/Rule/Tree/TreeRuleEditContext";
import { MissingRuleNode } from "./MissingRuleNode";
import { EvaluationNode } from "./EvaluationNode";
import { ResultRuleNode } from "./ResultRuleNode";
import { TreeRuleConfiguration } from "../../../rule-engine-core/Rule/Tree/TreeRuleConfiguration";
import { ObserveMultiState } from "../../../CommonUI/StateManagement/ObserveMultiState";
import { TreeRuleBuilder } from "../TreeRuleBuilder";

export interface TreeRuleNodeProps {
    node: TreeRuleNode;
    editContext: TreeRuleEditContext;
    ruleDefinition: TreeRuleConfiguration;
    treeRuleBuilder?: TreeRuleBuilder;
}

export const XTreeRuleNode = (props: {
    node: TreeRuleNode;
    editContext: TreeRuleEditContext;
    ruleDefinition: TreeRuleConfiguration;
    treeRuleBuilder?: TreeRuleBuilder;
}) => {
    const { node, ruleDefinition } = props;

    return (
        <ObserveMultiState
            listenTo={[ruleDefinition, node]}
            control={() => {
                if (!node) return null;

                switch (node.nodeType) {
                    case TreeRuleNodeType.EVALUATION:
                        return <EvaluationNode {...props} />;
                    case TreeRuleNodeType.UNDEFINED:
                        return <MissingRuleNode {...props} />;
                    case TreeRuleNodeType.RESULT:
                        return <ResultRuleNode {...props} />;
                    default:
                        return null;
                }
            }}
        />
    );
};
